module.exports = ".btn_sticky {\n  position: fixed;\n  bottom: 1%;\n  right: 1%;\n  z-index: 9999; }\n"